/* eslint-disable import/no-extraneous-dependencies */
import HttpService from '@pingum/api-services/HttpService';

export default class SuggestionService {
  static updateHorseSuggestion(id, request) {
    if (!id) {
      return Promise.reject(new Error('Missing Horse Suggestion ID'));
    }

    return new Promise((resolve, reject) => {
      this.httpService.patch(`/${id}`, request).then(
        (response) => {
          resolve(response);
        },
        (error) => reject(new Error(error.data.message)),
      );
    });
  }
}

SuggestionService.httpService = new HttpService({
  baseURL: `${
    typeof window !== 'undefined'
      ? env.REACT_APP_HORSE_API
      : ''
  }/horseSuggestions`,
});
